<div class="form-element">
  <label *ngIf="label" [style]="{ 'justify-content': label ? 'space-between' : 'flex-end' }">
    <span *ngIf="label">{{ label }}</span>
  </label>

  <p-inputGroup>
    @if (contentLeftTemplate) {
      <p-inputGroupAddon>
        <ng-container [ngTemplateOutlet]="contentLeftTemplate"></ng-container>
      </p-inputGroupAddon>
    }
    <p-inputNumber [(ngModel)]="value"
                   [format]="format"
                   [showButtons]="showButtons"
                   [buttonLayout]="buttonLayout"
                   [locale]="locale"
                   [localeMatcher]="localeMatcher"
                   [mode]="mode"
                   [prefix]="prefix"
                   [suffix]="suffix"
                   [currency]="currency"
                   [currencyDisplay]="currencyDisplay"
                   [useGrouping]="useGrouping"
                   [minFractionDigits]="minFractionDigits"
                   [maxFractionDigits]="maxFractionDigits"
                   [min]="min"
                   [max]="max"
                   [step]="step"
                   [styleClass]="styleClass"
                   [placeholder]="placeholder"
                   [maxlength]="maxlength"
                   [tabindex]="tabindex"
                   [disabled]="disabled"
                   [autocomplete]="autocomplete"
                   [decrementButtonClass]="'cap-button ' + decrementButtonClass"
                   [incrementButtonClass]="'cap-button ' + incrementButtonClass"
                   [decrementButtonIcon]="decrementButtonIcon"
                   [incrementButtonIcon]="incrementButtonIcon"
                   [readonly]="readonly"
                   (onFocus)="onFocus($event)"
                   (onBlur)="onBlur($event)">
    </p-inputNumber>

    @if (contentRightTemplate) {
      <p-inputGroupAddon>
        <ng-container [ngTemplateOutlet]="contentRightTemplate"></ng-container>
      </p-inputGroupAddon>
    }
  </p-inputGroup>

  <cap-validator *ngIf="control" [control]="control" [customName]="label"></cap-validator>
</div>
